import React from 'react'
import { useState,useEffect } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_USER_ONE_DAY_TIMER } from '../../../redux/actions/types';

const ChallengeTimer = () => {
  const [time, setTime] = useState({});
  const [isNegative, setIsNegative] = useState(false)
  const timerRef = useRef();
  const dispatch = useDispatch();
  const count = 0;
  // The data/time we want to countdown to
  const countDownDate = useSelector(store=> store?.userActivity?.user_one_day_timer);
  
  // console.log({countDownDate})
  if(countDownDate=== undefined || countDownDate === null){
    dispatch({type : SET_USER_ONE_DAY_TIMER , payload : Date.now() + 60*60*1000})
  }
  
  
  useEffect(
    () => {
      timerRef.current = setInterval(function () {
        const now = new Date().getTime();
        const timeleft = countDownDate - now;

        const hours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

        if (timeleft < 0) {
          clearInterval(timerRef.current);
          dispatch({type : SET_USER_ONE_DAY_TIMER , payload : Date.now() + 60*60*1000})
        }
        // Result is output to the specific element
        // document.getElementById('days').innerHTML = days + 'd ';
        setTime({ h: hours, m: minutes, s: seconds });

        // Display the message when countdown is over
      }, 1000);
      return () => {
        clearInterval(timerRef.current);
      }
    },
    [countDownDate],
    
  );
  return (
   <>
    {
        !isNegative ?
          <div className="flex items-center justify-center font-bold text-red-800 border-2 text-xs md:text-lg border-red-800 bg-white rounded-md md:px-2 mx-2 md:mx-2 w-fit">
            <div className="flex gap-1 w-full px-2">
              <div className="text-center">{time?.h}H</div>
              <div className="row-span-1 md:row-span-2 text-center ">:</div>
              <div className="text-center">{time?.m}M</div>
              <div className="row-span-1 md:row-span-2 text-center">:</div>
              <div className="text-center">{time?.s}S</div>
              <div className="text-center">Left</div>
            </div>
          </div>
          : null
      }
    </> 
  )
}

export default ChallengeTimer;
